import { toggleButtonGroupClasses } from '@mui/material';

export const groupStyles = {
  borderRadius: '8px',
  backgroundColor: ({ palette }) => palette.background.segmentTrack,
  marginBottom: '16px',

  [`& .${toggleButtonGroupClasses.grouped}`]: {
    margin: '2px',
    textTransform: 'none',
    borderRadius: '6px',
    border: 'none',
    padding: '0 8px',
    color: ({ palette }) => palette.text.secondary,

    '&:hover': {
      backgroundColor: ({ palette }) => palette.background.paper,
    },
  },

  [`& .${toggleButtonGroupClasses.grouped}.${toggleButtonGroupClasses.selected}`]: {
    backgroundColor: ({ palette }) => palette.background.segmentSelected,
    color: ({ palette }) => palette.text.primary,

    '&:hover': {
      backgroundColor: ({ palette }) => palette.background.segmentSelected,
    },
  },
};

export const tabContentStyles = {
  display: 'inline-flex',
  alignItems: 'center',
  gap: '6px',
};

export const getBadgeStyles =
  ({ isActive }) =>
  ({ palette }) => ({
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    minWidth: '18px',
    height: '18px',
    padding: '0 6px',
    borderRadius: '10px',
    color: isActive ? palette.info.dark : palette.text.dark,
    backgroundColor: isActive ? palette.info.soft : palette.background.hoverDefault,
  });
